import { useEffect, useState } from "react";

const typing = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  return tag === "TEXTAREA" || tag === "SELECT" || tag === "INPUT" || el.isContentEditable;
};

// D1 · ↑/↓ recorren los resultados, ←/→ cambian de versión, Enter elige la versión.
// No actúan con el foco en un input/select/textarea; Esc en el buscador suelta el foco para navegar.
export function useResultsKeyboard({ results, enabled, onPick, searchRef, resetKey }) {
  const [index, setIndex] = useState(-1);
  const [version, setVersion] = useState(0);

  useEffect(() => { setIndex(-1); setVersion(0); }, [results, resetKey]);

  useEffect(() => {
    if (!enabled || !results.length) { return undefined; }
    const onKey = (e) => {
      if (e.key === "Escape" && document.activeElement === searchRef?.current) { searchRef.current.blur(); return; }
      if (typing(document.activeElement)) return;
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        const step = e.key === "ArrowDown" ? 1 : -1;
        setIndex((i) => Math.max(0, Math.min(results.length - 1, i + step)));
        setVersion(0);
      } else if ((e.key === "ArrowRight" || e.key === "ArrowLeft") && index >= 0) {
        const n = results[index]?.versions?.length || 0;
        if (!n) return;
        e.preventDefault();
        setVersion((v) => (v + (e.key === "ArrowRight" ? 1 : n - 1)) % n);
      } else if (e.key === "Enter" && index >= 0) {
        e.preventDefault();
        e.stopPropagation();
        const c = results[index];
        onPick(c, c.versions?.[version] || null);
      }
    };
    window.addEventListener("keydown", onKey, true);
    return () => { window.removeEventListener("keydown", onKey, true); };
  }, [enabled, results, index, version, onPick, searchRef]);

  return { activeIndex: index, activeVersion: version, setActiveIndex: setIndex };
}
